import React from 'react';
import { Form } from './componets/Form';

export const App = () => {
  return (
    <div>
      <Form />
    </div>
  );
};
